import React , { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Notification, Typography, Box } from '@telus-uds/components-web';


const MessageNotification = ({ message, variant }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 6000);

    // Clear the timer if the component is unmounted
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const isInfo = !variant || variant === 'info' || variant === 'default';
  const isDismissible = variant === 'success';
  const notificationProps = isInfo ? {} : { variant: { validation: variant } };

  return (
    <div style={{ width: '85%', marginLeft: 'auto', marginRight: 'auto' }}>
      <Box top={2} bottom={2}>
        <Notification
          {...notificationProps}
          dismissible={isDismissible}
          copy="en"
        >
          <Typography variant={{ bold: true }}>{message}</Typography>
        </Notification>
      </Box>
    </div>
  );
};

MessageNotification.propTypes = {
  message: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'default'])
};

export default MessageNotification;